import React, {PureComponent} from 'react';

class Icon extends PureComponent {

    render() {
        const { name, size="md", ...rest } = this.props;
        return (
            <svg className={`bmw-icon-${size}`} {...rest}>
                <use xlinkHref={`#${name}`}></use>
            </svg>
        );
    }
}


export default Icon;



// WEBPACK FOOTER //
// ./src/components/common/icon/Icon.js